import { path } from 'd3-path'
import Symbol2d from '../2d.js'

/*
 * This was built in inkscape for a 160x100 svg shape (cloud)
 */
export default class Cloud extends Symbol2d {

  path (dimensions, handles) {
    const _path = path()
    // First start curve for bottom right bubble
    _path.moveTo(dimensions.width, dimensions.height * 0.71)

    _path.bezierCurveTo(
      dimensions.width, dimensions.height * 0.85,
      dimensions.width * 0.92, dimensions.height,
      dimensions.width * 0.82, dimensions.height,
    ) // First curve on bottom right corner

    _path.lineTo(dimensions.width * 0.18, dimensions.height) // Bottom line

      // Now 4 curves to the left heading up on the left side
    _path.bezierCurveTo(
      dimensions.width * 0.08, dimensions.height,
      0, dimensions.height * 0.87,
      0, dimensions.height * 0.71,
    ) // First curve on bottom left corner

    _path.bezierCurveTo(
      0, dimensions.height * 0.55,
      dimensions.width * 0.08, dimensions.height * 0.42,
      dimensions.width * 0.17, dimensions.height * 0.42,
    ) // Second upper curve on bottom left corner

    _path.bezierCurveTo(
      dimensions.width * 0.19, dimensions.height * 0.31,
      dimensions.width * 0.28, dimensions.height * 0.22,
      dimensions.width * 0.36, dimensions.height * 0.25,
    ) // Third curve

    _path.bezierCurveTo(
      dimensions.width * 0.41, dimensions.height * 0.10,
      dimensions.width * 0.51, 0,
      dimensions.width * 0.61, 0
    ) // Fourth curve

    // Now we're at the top middle, curving down to the right
    _path.bezierCurveTo(
      dimensions.width * 0.79, 0,
      dimensions.width * 0.89, dimensions.height * 0.20,
      dimensions.width * 0.90, dimensions.height * 0.45,
    )

    _path.bezierCurveTo(
      dimensions.width * 0.96, dimensions.height * 0.49,
      dimensions.width, dimensions.height * 0.60,
      dimensions.width, dimensions.height * 0.71,
    ) // Final curve back to the start.

    _path.closePath()
    return _path.toString()
  }

  textContainer (dimensions) {
    const x1 = dimensions.width * 0.17
    const x2 = dimensions.width * 0.9

    const y1 = dimensions.height * 0.42
    const y2 = dimensions.height

    const width = x2 - x1
    const height = y2 - y1

    const centerX = x1 + width / 2
    const centerY = y1 + height / 2

    return {
      center: [centerX, centerY],
      width,
      height
    }
  }
}
